import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const Plus: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[16px] h-[16px]', className)}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.99948 2.13342H9.99948H10.6661C10.9607 2.13342 11.1995 2.3722 11.1995 2.66676C11.1995 2.96131 10.9607 3.20009 10.6661 3.20009H10.5328V6.54085L11.8098 9.09491C11.8469 9.16896 11.8661 9.25063 11.8661 9.33342V10.6668C11.8661 10.9613 11.6274 11.2001 11.3328 11.2001H8.53281V14.0001C8.53281 14.2946 8.29403 14.5334 7.99948 14.5334C7.70493 14.5334 7.46615 14.2946 7.46615 14.0001V11.2001H4.66615C4.37159 11.2001 4.13281 10.9613 4.13281 10.6668V9.33342C4.13281 9.25063 4.15209 9.16896 4.18912 9.09491L5.46615 6.54085V3.20009H5.33281C5.03826 3.20009 4.79948 2.96131 4.79948 2.66676C4.79948 2.3722 5.03826 2.13342 5.33281 2.13342H5.99948ZM9.46615 3.20009V6.66676C9.46615 6.74955 9.48542 6.83121 9.52245 6.90527L10.7995 9.45933V10.1334H5.19948V9.45933L6.47651 6.90527C6.51354 6.83121 6.53281 6.74955 6.53281 6.66676V3.20009H9.46615Z"
      fill="#FF611A"
    />
  </svg>
);

export default Plus;
